import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PreviousUrlService {
  private previousUrl: string;
  private currentUrl: string;
  private currentStartURL;

  constructor(
    private router: Router
  ) {
    this.currentUrl = this.router.url;
    router.events.subscribe(event => {
      if(event instanceof NavigationStart){
        this.currentStartURL = event.url;
      }
      
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
      };
    });
  }

  public getPreviousUrl() {
    return this.previousUrl;
  }

  public getCurrentUrl(){
    return this.currentStartURL;
  }
}
